export default "__VITE_ASSET__BAbJEZAJ__"